/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_1_HeadingInputs */

const en_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`National Recognition`)
};

const es_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconocimiento nacional`)
};

const de_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationale Anerkennung`)
};

const zh_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全国性荣誉`)
};

const ar_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اعتراف وطني`)
};

const fr_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnaissance nationale`)
};

const vi_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công nhận quốc gia`)
};

const sw_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kutambuliwa Kitaifa`)
};

const th_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การยอมรับระดับประเทศ`)
};

const bs_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nacionalno priznanje`)
};

const ja_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全国的な評価`)
};

const ko_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전국적 인정`)
};

const pt_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconhecimento nacional`)
};

const it_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riconoscimento nazionale`)
};

const sv_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationellt erkännande`)
};

const nl_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationale erkenning`)
};

const da_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`National anerkendelse`)
};

const nb_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasjonal anerkjennelse`)
};

const fi_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kansallinen tunnustus`)
};

const pl_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uznanie krajowe`)
};

const ru_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Национальное признание`)
};

const tr_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulusal Tanınma`)
};

const hi_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`राष्ट्रीय मान्यता`)
};

const id_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengakuan Nasional`)
};

const ms_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengiktirafan Kebangsaan`)
};

const cs_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celostátní uznání`)
};

const el_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εθνική αναγνώριση`)
};

const he_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הכרה לאומית`)
};

const af_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasionale erkenning`)
};

const hu_about_content_honor_1_heading = /** @type {(inputs: About_Content_Honor_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemzeti elismerés`)
};

/**
* | output |
* | --- |
* | "National Recognition" |
*
* @param {About_Content_Honor_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_1_heading = /** @type {((inputs?: About_Content_Honor_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_1_heading(inputs)
	if (locale === "de") return de_about_content_honor_1_heading(inputs)
	if (locale === "zh") return zh_about_content_honor_1_heading(inputs)
	if (locale === "ar") return ar_about_content_honor_1_heading(inputs)
	if (locale === "fr") return fr_about_content_honor_1_heading(inputs)
	if (locale === "vi") return vi_about_content_honor_1_heading(inputs)
	if (locale === "sw") return sw_about_content_honor_1_heading(inputs)
	if (locale === "th") return th_about_content_honor_1_heading(inputs)
	if (locale === "bs") return bs_about_content_honor_1_heading(inputs)
	if (locale === "ja") return ja_about_content_honor_1_heading(inputs)
	if (locale === "ko") return ko_about_content_honor_1_heading(inputs)
	if (locale === "pt") return pt_about_content_honor_1_heading(inputs)
	if (locale === "it") return it_about_content_honor_1_heading(inputs)
	if (locale === "sv") return sv_about_content_honor_1_heading(inputs)
	if (locale === "nl") return nl_about_content_honor_1_heading(inputs)
	if (locale === "da") return da_about_content_honor_1_heading(inputs)
	if (locale === "nb") return nb_about_content_honor_1_heading(inputs)
	if (locale === "fi") return fi_about_content_honor_1_heading(inputs)
	if (locale === "pl") return pl_about_content_honor_1_heading(inputs)
	if (locale === "ru") return ru_about_content_honor_1_heading(inputs)
	if (locale === "tr") return tr_about_content_honor_1_heading(inputs)
	if (locale === "hi") return hi_about_content_honor_1_heading(inputs)
	if (locale === "id") return id_about_content_honor_1_heading(inputs)
	if (locale === "ms") return ms_about_content_honor_1_heading(inputs)
	if (locale === "cs") return cs_about_content_honor_1_heading(inputs)
	if (locale === "el") return el_about_content_honor_1_heading(inputs)
	if (locale === "he") return he_about_content_honor_1_heading(inputs)
	if (locale === "af") return af_about_content_honor_1_heading(inputs)
	if (locale === "hu") return hu_about_content_honor_1_heading(inputs)
	return en_about_content_honor_1_heading(inputs)
});